<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    DAFTAR PASIEN OPERASI
                </h1>
            </div>
            <div class="w-full md:w-1/2 mt-5 mx-auto">
                <SelectInput
                            v-model="statusData"
                            id="status"
                            label="STATUS"
                        >
                            <option value="">=== PILIH STATUS ===</option>
                            <option value="all">Semua</option>
                            <option value="tgldaftar">Tgl Daftar</option>
                            <option value="tglop">Tgl OP</option>
                </SelectInput>
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-5 mx-auto">
                <DateInput
                    v-if="statusData != 'all'"
                    v-model="tglMasukData"
                    class="w-full grow mr-5"
                    id="tgl_masuk"
                    label="PILIH TANGGAL"
                />
            </div>
            <div class="w-full flex md:w-1/2 mx-auto">
                <!-- <button
                    @click.prevent="exportExcel()"
                    class="bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs mr-2"
                >
                    EXPORT EXCEL
                </button> -->
                <button
                    @click.prevent="getRekapPasienIbs()"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center w-36 h-10 text-xs"
                >
                    CARI
                </button>
            </div>
            <div class="w-full my-3">
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm">
                        data diperbaharui pada :
                        <span class="text-red-500"
                            >{{ timerCount }} (10 Menit)</span
                        >
                    </p>
                </div>
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8">
                <table class="w-full whitespace-nowrap">
                    <thead>
                        <tr class="text-left font-bold bg-amber-100">
                            <th class="py-2 px-3 text-center text-sm">Aksi</th>
                            <th class="py-2 px-3 text-center text-sm">Kode</th>
                            <th class="py-2 px-3 text-center text-sm">Tanggal</th>
                            <th class="py-2 px-3 text-center text-sm">Jam</th>
                            <th class="py-2 px-3 text-center text-sm">Register</th>
                            <th class="py-2 px-3 text-center text-sm">No.RM</th>
                            <th class="py-2 px-3 text-center text-sm">Nama Pasien</th>
                            <th class="py-2 px-3 text-center text-sm">Tgl OP</th>
                            <th class="py-2 px-3 text-center text-sm">
                                Jam OP
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Nama OP
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Bangsal Awal
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Operator
                            </th>
                            <th class="py-2 px-3 text-center text-sm">Tanggal Exit OP</th>
                            <th class="py-2 px-3 text-center text-sm">
                                Tarif RS
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Diag Utama
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Diagnosa Text
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="pasien in rekapPasienIbsData.pasien"
                            class="hover:bg-gray-100"
                        >
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                <button @click.prevent="showBerkas(pasien.fs_kd_reg, pasien.fs_mr)" class="bg-blue-500 text-white px-4 py-2 rounded">
                                    Berkas
                                </button>
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_kd_trs }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fd_tgl_trs }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_jam_trs }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_kd_reg }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_mr }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_nm_pasien }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fd_tgl_op }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_jam_op }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_nm_op }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_nm_layanan }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_nm_operator }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fd_tgl_keluar_op }} {{ pasien.fs_jam_keluar_op }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-end">
                                {{ Number(pasien.tarif_rs).toLocaleString("en-US") }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasien.fs_kd_diag_utama }} - {{ pasien.fs_nm_diag_utama }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ potongTeks(pasien.fs_diag_utama, 100) }} 
                            </td>
                        </tr>
                        <tr class="bg-white hover:bg-gray-100 focus-within:bg-gray-100" v-if="rekapPasienIbsData.length === 0">
                            <td class="border-r border-t text-sm select-none cursor-pointer" colspan="15">
                                Belum ada data pasien operasi
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div id="myModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center hidden z-50">
        <div class="bg-white p-8 rounded-xl shadow-2xl max-w-3xl w-full mx-4">
            <h2 class="text-2xl font-bold mb-6">Berkas Ranap</h2>
          
            <!-- content -->
            <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8">
                <table class="w-full whitespace-nowrap">
                    <thead>
                        <tr class="text-left font-bold bg-amber-100">
                            <th class="py-2 px-3 text-center text-sm">Aksi</th>
                            <th class="py-2 px-3 text-center text-sm">Kode</th>
                            <th class="py-2 px-3 text-center text-sm">Nama Berkas</th>
                            <th class="py-2 px-3 text-center text-sm">Kode Upload</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="berkas in berkasPasienRanapData"
                            class="hover:bg-gray-100"
                        >
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                <a :href="`http://192.10.10.30:8181/storage/file_upload/${selectedBerkasData.fsMr}/${berkas.FS_NM_DOK}.pdf`" class="bg-blue-500 text-white px-4 py-2 rounded" target="_blank"> Lihat</a>
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                {{ berkas.FS_JNS_DOK }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                {{ berkas.FS_NM_MANUAL }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-center">
                                {{ berkas.FS_NM_DOK }}
                            </td>
                        </tr>
                        <tr class="bg-white hover:bg-gray-100 focus-within:bg-gray-100" v-if="berkasPasienRanapData.length === 0">
                            <td class="border-r border-t text-sm select-none cursor-pointer" colspan="4">
                                Belum ada data berkas pasien 
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            <!-- end of content -->


            <div class="flex justify-end">
            <button onclick="document.getElementById('myModal').classList.add('hidden')" class="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700">
                Tutup
            </button>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdminBig from "../../../Shared/LayoutAdminBig.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
        TextInput,
        SelectInput
    },
    data() {
        return {
            tglMasukData: this.tglMasuk,
            statusData: this.status,
            rekapPasienIbsData: this.rekapPasienIbs,
            timerCount: 600,
            berkasPasienRanapData: [],
            selectedBerkasData: {
                fsKdReg: "",
                fsMr: ""
            }
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getRekapPasienIbs();
                }
            },
            immediate: true,
        },
    },
    props: {
        tglMasuk: String,
        status: String,
        rekapPasienIbs: Object,
    },
    methods: {
        getRekapPasienIbs() {
            this.$inertia.get(
                "/admin/rekap_pasien_ibs/ajax",
                {
                    tglMasuk: this.tglMasukData,
                    status: this.statusData
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.timerCount = 600;
                        this.rekapPasienIbsData = page.props.additional.rekapPasienIbs;
                    },
                }
            );
        },
        potongTeks(teks, panjang = 100) {
            if (!teks) return '';
            return teks.length > panjang ? teks.slice(0, panjang) + '...' : teks;
        },
        showBerkas(fsKdReg,fsMr){
            this.selectedBerkasData.fsKdReg = fsKdReg;
            this.selectedBerkasData.fsMr = fsMr;
            this.$inertia.get(
                "/admin/rekap_pasien_ibs/berkas",
                {
                    fsKdReg: fsKdReg
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.berkasPasienRanapData = page.props.additional.berkasPasienRanap;
                        document.getElementById('myModal').classList.remove('hidden');
                    },
                }
            );
            
        }
        // exportExcel(){
        //     location.href = '/admin/pasien_igd/export/excel?tglMasuk='+this.tglMasukData+'&status='+this.statusData;
        // }
    },
    layout: LayoutAdminBig,
};
</script>
